import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/document-services/document-services/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const TextBlock = makeShortcode("TextBlock");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <TextBlock slots="heading,text,image" theme="lightest" headerElementType="h2" variantsTypePrimary='secondary' isPrimaryBtn homeZigZag className="home-zigzag-comp-padding Adobe-PDF-Services-API ms-zigzag-cta-one zigzag-align zig-zag-cont-one" mdxType="TextBlock" />
    <h3 {...{
      "id": "make-critical-business-documents-tamper-evident"
    }}>{`Make critical business documents tamper-evident`}</h3>
    <p>{`Detect any tampering made to bills, invoices, employee verification documents, and other critical documents after the e-seal was applied.`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1093px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "72.8125%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/static/456dc98eb58e526c0593b53fb5f6a538/5530d/E_Seal_Tampering_F_Desktop.webp 320w", "/document-services/static/456dc98eb58e526c0593b53fb5f6a538/0c8fb/E_Seal_Tampering_F_Desktop.webp 640w", "/document-services/static/456dc98eb58e526c0593b53fb5f6a538/b9a13/E_Seal_Tampering_F_Desktop.webp 1093w"],
            "sizes": "(max-width: 1093px) 100vw, 1093px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/static/456dc98eb58e526c0593b53fb5f6a538/dd4a7/E_Seal_Tampering_F_Desktop.png 320w", "/document-services/static/456dc98eb58e526c0593b53fb5f6a538/0f09e/E_Seal_Tampering_F_Desktop.png 640w", "/document-services/static/456dc98eb58e526c0593b53fb5f6a538/994d6/E_Seal_Tampering_F_Desktop.png 1093w"],
            "sizes": "(max-width: 1093px) 100vw, 1093px",
            "type": "image/png"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/document-services/static/456dc98eb58e526c0593b53fb5f6a538/994d6/E_Seal_Tampering_F_Desktop.png",
            "alt": "EMPTY_ALT",
            "title": "EMPTY_ALT",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <TextBlock slots="image,heading,text" theme="lightest" headerElementType="h2" variantsTypePrimary='secondary' isPrimaryBtn homeZigZag className="home-zigzag-comp-padding Adobe-PDF-Services-API ms-zigzag-cta-one zigzag-align zig-zag-cont-two" mdxType="TextBlock" />
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1093px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "72.8125%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/static/603be12d5b838848f057a121b71be5dd/5530d/E_seal_Automation_F_Desktop.webp 320w", "/document-services/static/603be12d5b838848f057a121b71be5dd/0c8fb/E_seal_Automation_F_Desktop.webp 640w", "/document-services/static/603be12d5b838848f057a121b71be5dd/b9a13/E_seal_Automation_F_Desktop.webp 1093w"],
            "sizes": "(max-width: 1093px) 100vw, 1093px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/static/603be12d5b838848f057a121b71be5dd/dd4a7/E_seal_Automation_F_Desktop.png 320w", "/document-services/static/603be12d5b838848f057a121b71be5dd/0f09e/E_seal_Automation_F_Desktop.png 640w", "/document-services/static/603be12d5b838848f057a121b71be5dd/994d6/E_seal_Automation_F_Desktop.png 1093w"],
            "sizes": "(max-width: 1093px) 100vw, 1093px",
            "type": "image/png"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/document-services/static/603be12d5b838848f057a121b71be5dd/994d6/E_seal_Automation_F_Desktop.png",
            "alt": "EMPTY_ALT",
            "title": "EMPTY_ALT",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <h3 {...{
      "id": "enable-end-to-end-automated-sealing-workflows"
    }}>{`Enable end-to-end automated sealing workflows`}</h3>
    <p>{`Automated document e-sealing workflows help avoid human error that may otherwise occur when using document based process internally and with external vendors or partners.`}</p>
    <TextBlock slots="heading,text,image" theme="lightest" headerElementType="h2" variantsTypePrimary='secondary' isPrimaryBtn homeZigZag className="home-zigzag-comp-padding Adobe-PDF-Services-API ms-zigzag-cta-one zigzag-align zig-zag-cont-three link" mdxType="TextBlock" />
    <h3 {...{
      "id": "meet-security-and-reliability-needs"
    }}>{`Meet security and reliability needs`}</h3>
    <p>{`Meet enterprise-grade security and reliability needs from the leader in digital document solutions. Achive compliance for eIDAS with e-seals. Learn
more about compliance `}<a href="https://www.adobe.com/trust/compliance/compliance-list.html">{`here.`}</a></p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1093px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "72.8125%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/static/97e77c4ac7d32a784a5b4e906ae702ad/5530d/E_Seal_Secure_F_Destkop.webp 320w", "/document-services/static/97e77c4ac7d32a784a5b4e906ae702ad/0c8fb/E_Seal_Secure_F_Destkop.webp 640w", "/document-services/static/97e77c4ac7d32a784a5b4e906ae702ad/b9a13/E_Seal_Secure_F_Destkop.webp 1093w"],
            "sizes": "(max-width: 1093px) 100vw, 1093px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/document-services/static/97e77c4ac7d32a784a5b4e906ae702ad/dd4a7/E_Seal_Secure_F_Destkop.png 320w", "/document-services/static/97e77c4ac7d32a784a5b4e906ae702ad/0f09e/E_Seal_Secure_F_Destkop.png 640w", "/document-services/static/97e77c4ac7d32a784a5b4e906ae702ad/994d6/E_Seal_Secure_F_Destkop.png 1093w"],
            "sizes": "(max-width: 1093px) 100vw, 1093px",
            "type": "image/png"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/document-services/static/97e77c4ac7d32a784a5b4e906ae702ad/994d6/E_Seal_Secure_F_Destkop.png",
            "alt": "EMPTY_ALT",
            "title": "EMPTY_ALT",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      